// extracted by mini-css-extract-plugin
module.exports = {"row":"VehicleReportStatusTable_row_2-cKs","inTraffic":"VehicleReportStatusTable_inTraffic_1z5Bx","notInTraffic":"VehicleReportStatusTable_notInTraffic_2bPDN"};